
import { Users as LucideUsers, Settings as LucideSettings, BarChart3, Activity as LucideActivity, PhilippinePeso } from 'lucide-react';
export const PesoSign: React.FC<{ className?: string }> = ({ className = '' }) => (
  <PhilippinePeso className={className} size={24} color="#059669" />
);
export const Activity: React.FC<{ className?: string }> = ({ className = '' }) => (
  <LucideActivity className={className} size={32} color="#2bd4bd" />
);

export const Users: React.FC<{ className?: string }> = ({ className = '' }) => (
  <LucideUsers className={className} size={32} color="#2bd4bd" />
);

export const Settings: React.FC<{ className?: string }> = ({ className = '' }) => (
  <LucideSettings className={className} size={32} color="#2bd4bd" />
);

export const ChartNoAxesCombined: React.FC<{ className?: string }> = ({ className = '' }) => (
  <BarChart3 className={className} size={32} color="#2bd4bd" />
);

// Eye icon component for password visibility toggle
export const EyeIcon: React.FC<{ show: boolean; className?: string }> = ({ show, className = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {show ? (
      // Eye with slash (hidden)
      <>
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </>
    ) : (
      // Eye (visible)
      <>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </>
    )}
  </svg>
);

// Close/X icon component
export const CloseIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

// Arrow left/back icon component
export const ArrowLeftIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M19 12H5" />
    <path d="M12 19l-7-7 7-7" />
  </svg>
);

